import React from 'react'
import { SearchProvider } from '../../context/Search'
import SearchButton from './Button'
import SearchModal from './Modal'
import { SearchOptions } from '@algolia/client-search'
import { useTranslation } from 'react-i18next'

declare const DOCSEARCH_CONFIG: DocSearchConfig

interface SearchProps {
  modalTitle?: string
  hideProductText?: boolean
  options?: SearchOptions
}

export default function Search({
  modalTitle,
  hideProductText = false,
  options = {},
}: SearchProps) {
  const { appId, apiKey, indexName } = DOCSEARCH_CONFIG
  const { t } = useTranslation()

  // Disable search if any config details are missing
  if (!appId || !apiKey || !indexName) {
    return null
  }

  options = {
    attributesToRetrieve: ['*'],
    highlightPreTag: '<span class="Item__Highlight">',
    highlightPostTag: '</span>',
    snippetEllipsisText: '...',
    ...options,
  }

  return (
    <SearchProvider>
      <SearchButton label={t('search.label')} />
      <SearchModal
        modalTitle={modalTitle || t('search.modalTitle')}
        hideProductText={hideProductText}
        inputLabel={t('search.label')}
        searchOptions={options}
      />
    </SearchProvider>
  )
}
